export default __webpack_public_path__ + "static/media/hht2_ep17_speaking_04.d85ef40d.png";